/* Shop the Silhouette drawer: colour swatch + size -> variant.
   For products with colour swatches, picking a colour rebuilds the size list for that colour,
   then the hidden "id" input, the Add button and the product image follow the matching variant. */
(function () {
  if (window.__silColourInit) return;
  window.__silColourInit = true;

  function currentColour(form) {
    var on = form.querySelector('.silhouette__swatch[aria-pressed="true"]');
    return on ? on.getAttribute('data-sil-colour') : null;
  }

  function sync(form, changed) {
    var cfgEl = form.querySelector('[data-sil-variants]');
    var idInput = form.querySelector('[data-sil-variant-id]');
    var sizeSel = form.querySelector('[data-sil-option="size"]');
    var colour = currentColour(form);
    if (!cfgEl || !idInput || colour === null) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (err) { return; }

    var rows = cfg.variants.filter(function (v) { return v.o[cfg.colourIdx] === colour; });
    var chosen = null;

    if (sizeSel) {
      var best = {}, order = [];
      rows.forEach(function (v) {
        var s = v.o[cfg.sizeIdx];
        if (!(s in best)) { best[s] = v; order.push(s); }
        else if (!best[s].a && v.a) { best[s] = v; }
      });

      if (changed === 'colour') {
        var prev = sizeSel.value;
        while (sizeSel.firstChild) sizeSel.removeChild(sizeSel.firstChild);
        var pick = (prev in best && best[prev].a) ? prev : null;
        if (pick === null) {
          for (var i = 0; i < order.length; i++) { if (best[order[i]].a) { pick = order[i]; break; } }
        }
        if (pick === null && order.length) pick = order[0];
        order.forEach(function (s) {
          var o = document.createElement('option');
          o.value = s;
          o.textContent = s + (best[s].a ? '' : ' — ' + cfg.sold);
          if (!best[s].a) o.disabled = true;
          if (s === pick) o.selected = true;
          sizeSel.appendChild(o);
        });
      }
      chosen = best[sizeSel.value] || null;
    } else {
      chosen = rows.filter(function (v) { return v.a; })[0] || rows[0] || null;
    }
    if (!chosen) return;

    idInput.value = chosen.id;

    var btn = form.querySelector('.product-form__submit');
    if (btn) {
      var label = btn.querySelector('span');
      if (chosen.a) { btn.removeAttribute('disabled'); btn.removeAttribute('aria-disabled'); }
      else { btn.setAttribute('disabled', 'disabled'); btn.setAttribute('aria-disabled', 'true'); }
      if (label) label.textContent = chosen.a ? cfg.add : cfg.sold;
    }

    if (changed === 'colour' && chosen.img) {
      var card = form.closest('.silhouette__product');
      var img = card && card.querySelector('.silhouette__product-img');
      if (img && img.tagName === 'IMG') { img.removeAttribute('srcset'); img.src = chosen.img; }
    }
  }

  document.addEventListener('click', function (e) {
    var sw = e.target && e.target.closest ? e.target.closest('.silhouette__swatch') : null;
    if (!sw || sw.disabled) return;
    var form = sw.closest('form');
    if (!form) return;
    form.querySelectorAll('.silhouette__swatch').forEach(function (b) {
      b.setAttribute('aria-pressed', b === sw ? 'true' : 'false');
    });
    sync(form, 'colour');
  });

  document.addEventListener('change', function (e) {
    var sel = e.target && e.target.closest ? e.target.closest('select[data-sil-option="size"]') : null;
    if (!sel) return;
    var form = sel.closest('form');
    if (form) sync(form, 'size');
  });
})();